/**
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// => This module contains the JS required by the projects équipe (a.k.a à-propos), and its gsap animations

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const team = () => {
    const vh = window.innerHeight / 100;

    // [ANIMATION] TEAM INNER SHADOW ORANGE
    // -> Shows an orange inner shadown in team pictures on mouse hover, then people's name and role
    // -> On mouse leave, fades them out
    let teamBoxes = document.querySelectorAll(".team-hover-wrapper");
    for (let teamBox of teamBoxes) {
        // Variables
        let itemsToFade = teamBox.querySelectorAll(".team-name, img");
        gsap.set(itemsToFade, { pointerEvents: "none" });

        // SET TIMELINE
        let TL_TEAM_INNER_NAME = gsap.timeline({
            paused: true
        });

        TL_TEAM_INNER_NAME.to(teamBox, {
            boxShadow: "inset 0px 0px 0px 4vw #f05423",
            duration: 0.25
        }).to(itemsToFade, { autoAlpha: 1 }, ">");

        // Animate on hover
        teamBox.addEventListener("mouseenter", () => {
            TL_TEAM_INNER_NAME.seek(0);
            TL_TEAM_INNER_NAME.timeScale(1).play();
        });
        // Revert to close, but faster
        teamBox.addEventListener("mouseout", () => {
            TL_TEAM_INNER_NAME.pause();
            gsap.to(teamBox, {
            autoAlpha: 0,
            duration: 0.5,
            onComplete: () => {
                TL_TEAM_INNER_NAME.seek(0);
                gsap.set(teamBox, { autoAlpha: 1 });
            }
            });
        });
    }
    
    return;
}
